export default __webpack_public_path__ + "static/media/41cff5026a464e32.05638b2909593315c088f5875491ca80.svg";